@import "@/scss/use-bootstrap-mixins.scss";

#contact-card-modal {
  .card {
    overflow-y: auto;
  }
}

.hide {
  display: none !important;
}

.block {
  display: block !important;
}

.backdrop {
  position: fixed;
  z-index: 50;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;

  @include media-breakpoint-up(md) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card {
    background-color: #fff;
    border: 1px solid #888;
    max-width: 100vw;
    width: 100%;
    padding: 12px;
    border-radius: 12px;
    position: fixed;
    max-height: 100vh;
    font-size: 14px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 60;
    overflow-y: scroll;

    @include iPhoneSE {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    @include media-breakpoint-up(md) {
      width: 600px;
      margin: 0 auto;
      bottom: revert;
      top: revert;
      left: revert;
      right: revert;
      overflow: auto;
    }

    .header {
      display: flex;
      justify-content: center;
      height: 28px;
      align-items: center;

      .back_btn {
        background-color: transparent;
        border: none;
        color: #808080;

        &:hover {
          cursor: pointer;
        }
      }

      .cta {
        color: #000;
        font-size: 18px !important;
        margin: 0;
        flex: 1;
        margin-left: 40px;
        text-align: center !important;

        @include media-breakpoint-up(sm) {
          font-size: 24px !important;
        }
      }

      .cancel_btn {
        border-radius: 30px;
        background-color: transparent;
        border: 1px solid #787878;
        height: 28px;
        color: #787878;
        line-height: 20px !important;
        font-size: 14px;
        padding: 4px 8px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .confirmation {
      text-align: center;

      .container {
        padding: 100px 0;

        svg {
          path {
            fill: $primary;
          }
        }

        .success_1 {
          font-size: 24px;
          display: block;
          margin: 0;
        }

        .success_2 {
          margin: 0;
        }
      }

      .close_btn {
        border-radius: 14px;
        background-color: $primary;
        height: 53px;
        color: #fff;
        width: 100%;
        display: block;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        border: 0;
        margin-top: 24px;
      }
    }

    .copy {
      .top {
        margin-top: 24px;
        display: flex;
        align-items: center;

        .detail_1 {
          font-size: 15px;
          font-weight: 600;
          margin: 0;
          flex: 1;
        }

        svg {
          path {
            stroke: $primary;
          }
        }
      }
      .detail_2 {
        margin: 14px 0 25px 0;
        color: #787878;
        font-weight: 500;
        font-size: 13px;
      }
    }

    .form {
      .name_row {
        display: flex;
        gap: 8px;

        .part {
          flex: 1;
          min-width: 0;
        }
      }

      .part {
        margin-bottom: 16px;

        .label {
          display: block;
          margin: 0;
          color: #787878;
          font-weight: 500 !important;
          font-size: 13px;
          padding-bottom: 4px;
        }

        .input {
          padding: 0 17px;
          width: 100%;
          border: 1px solid #d0d0d0;
          border-radius: 13px;
          height: 40px !important;
          transition: all 0.3s;

          @media (min-width: 347px) {
            height: 60px !important;
          }

          &:focus-visible {
            border-color: $primary;
            box-shadow: 0 0 0 1px $primary;
          }

          &:disabled {
            background-color: #f5f5f5;
          }
        }

        // PhoneInput component styling to match other inputs
        :global(.react-international-phone-input-container) {
          width: 100%;
          display: flex;
          border: 1px solid #d0d0d0;
          border-radius: 13px;
          transition: all 0.3s;
          background: #fff;
          
          &:focus-within {
            border: 1px solid $primary !important;
            box-shadow: 0 0 0 1px $primary !important;
            
            :global(.react-international-phone-country-selector-button) {
              border-right-color: $primary !important;
            }
          }
          
          :global(.react-international-phone-country-selector-button) {
            border: none;
            border-right: 1px solid #d0d0d0;
            border-radius: 12px 0 0 12px;
            height: 38px;
            padding: 0 12px;
            background: transparent;
            margin: 0;

            @media (min-width: 347px) {
              height: 58px;
            }

            &:hover {
              background: #f5f5f5;
            }

            &:focus {
              outline: none;
            }
          }

          :global(.react-international-phone-input) {
            padding: 0 17px;
            width: 100%;
            border: none;
            border-radius: 0 12px 12px 0;
            height: 38px;
            transition: all 0.3s;
            font-size: 14px;
            background: transparent;

            @media (min-width: 347px) {
              height: 58px;
            }

            &:focus-visible,
            &:focus {
              outline: none;
            }

            &:disabled {
              background-color: #f5f5f5;
            }
          }
        }

        .email_pills {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 8px;
        }

        .email_pill {
          padding: 4px 10px;
          border: 1px solid #d0d0d0;
          border-radius: 20px;
          background: #f5f5f5;
          font-size: 12px;
          color: #555;
          cursor: pointer;
          transition: all 0.2s;
          white-space: nowrap;

          &:hover {
            background: #e8e8e8;
            border-color: #999;
          }
        }

        .input_error {
          border-color: #dc3545 !important;

          &:focus-visible {
            box-shadow: 0 0 0 1px #dc3545 !important;
          }
        }

        .email_error_text {
          display: block;
          color: #dc3545;
          font-size: 12px;
          margin-top: 4px;
          padding-left: 4px;
        }

        .submit_btn {
          border-radius: 14px;
          background-color: $primary;
          height: 53px;
          color: $textColorOnPrimary !important;
          width: 100%;
          display: block;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          border: 0;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .policy_links {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: center;
        padding-top: 4px;
      }

      .policy_link {
        font-size: 12px;
        color: #787878;
        text-decoration: underline;
        text-underline-offset: 2px;

        &:hover {
          color: $primary;
        }
      }
    }
  }
}
